var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGraphicHeader(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 314.5 39.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            #graphic_header .cls-1 {\n                fill: #356359;\n            }\n\n            #graphic_header .cls-2 {\n                fill: #449e8a;\n            }\n\n            #graphic_header .cls-3 {\n                fill: #1a2442;\n            }\n\n            #graphic_header .cls-4 {\n                fill: #223361;\n            }\n\n            #graphic_header .cls-5 {\n                fill: #ae1831;\n            }\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "graphic_header",
    "data-name": "Laag 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Laag_2-2",
    "data-name": "Laag 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_38",
    "data-name": "Rectangle 38"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M314.5,0V39.25H238.87v-.14h75.49V.14h-58a1.07,1.07,0,0,1,.16-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M314.36.14v39H238.87a52.38,52.38,0,0,1,17.46-39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M256.49,0a1.07,1.07,0,0,0-.16.14H205.46a1,1,0,0,0,.08-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M205.46.14h50.87a52.38,52.38,0,0,0-17.46,39h-95A75.67,75.67,0,0,0,205.46.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M238.87,39.11v.14H139.19c1.58,0,3.15,0,4.71-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M205.54,0a1,1,0,0,1-.08.14H105.38L105.5,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M105.38.14H205.46a75.67,75.67,0,0,1-61.56,39H72.33l16.3-19.22L99.8,6.72ZM123.28,20h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M72.33,39.11H143.9c-1.56.09-3.13.14-4.71.14h-67l0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M105.5,0l-.12.14h-66A1.07,1.07,0,0,1,39.49,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M105.38.14,99.8,6.72,88.63,19.89,72.33,39.11H65.48A82.1,82.1,0,0,1,23.83,24.94,52.56,52.56,0,0,1,39.33.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M72.33,39.11l-.09.11q-1,0-1.95,0c-1.61,0-3.22,0-4.81-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M39.49,0a1.07,1.07,0,0,0-.16.14H.08A.64.64,0,0,1,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M.08.14H39.33a52.56,52.56,0,0,0-15.5,24.8A83.11,83.11,0,0,1,.08.14Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphicHeader);
export default __webpack_public_path__ + "static/media/graphic_header.f697a7432cf9baf39441cc6da8a7e161.svg";
export { ForwardRef as ReactComponent };